import { useContext, useState } from "react";
import { Redirect } from "react-router-dom";
import { useFormik } from "formik";
import axios from "axios";

import Context from "../../../context";
import FormField from "../Input/FormField";
import Button from "../Input/Button";
import { API_URL } from "../../data/constants";

export default function LoginPage() {
  const { contextState, setContextState } = useContext(Context);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState();
  const [submitting, setSubmitting] = useState(false);
  
  function validate(values) {
    const errors = {};
    if (!values.email) {
      errors.email = "Required";
    } /*else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email address";
    }*/

    if (!values.password) {
      errors.password = "Required";
    }

    return errors;
  }

  const loginForm = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validate,
    onSubmit: (values) => {
      setSubmitting(true);
      axios
        .post(API_URL + "/Auth/Login", {
          userName: values.email,
          password: values.password,
        })
        .then((res) => {
          if (res.status === 200 && res.data.accessToken) {
            localStorage.setItem("token", res.data.accessToken.token);
            localStorage.setItem("accessToken", `Bearer ${res.data.accessToken.token}`);
            localStorage.setItem("refreshToken", res.data.refreshToken);
            localStorage.setItem(
              "tokenTimeout",
              res.data.accessToken.expiresIn
            );
            localStorage.setItem("username", values.email);
            if (res.data.roles.length > 0){
              localStorage.setItem("userRole", res.data.roles[0].id);
            }
            setIsSubmitting(true);
            window.location.reload(false);
            setSubmitting(false);
          }
        })
        .catch((err) => {
          setSubmitting(false);
          setError("Incorrect username or password");
        });
    },
  });
  return (
    <>
      {isSubmitting ? (
        <Redirect to="/" />
      ) : (
        <>
          <form className="login-form" onSubmit={loginForm.handleSubmit}>
            {error && <p className="text-danger">{error}</p>}
            <FormField
              field="email"
              type="text"
              name="Email"
              form={loginForm}
            />
            <FormField
              field="password"
              type="password"
              name="Password"
              form={loginForm}
            />
            <Button
              className="btn btn-fluid btn--green btn--bordered"
              type="submit"
              disabled={!(loginForm.dirty && loginForm.isValid)}
              text="Sign In"
              submitting={submitting}
            />
          </form>

          <Button
            className="btn btn-fluid btn--blue btn--bordered"
            onClick={() => {
              setContextState({
                ...contextState,
                loginActivePage: "register",
              });
            }}
            type="submit"
            text="Create Profile"
          />

          <span
            className="login-link"
            onClick={() => {
              setContextState({ ...contextState, loginActivePage: "reset" });
            }}>
            Trouble logging in?
          </span>

         {/* <br/>
          <span style={{color:'white'}}>
            Interruptible Customers Login Below
          </span>
          <a href="https://portal.firesidenaturalgas.com/Sections/Main/Login.aspx" className="login-link">login</a>*/}
        </>
      )}
    </>
  );
}
